export const mapQuickSummaryInlineLinkingAgentResponseToMarkdown = (responseContent: any) => {
	if (
		!responseContent.keyTakeaways ||
		responseContent.keyTakeaways.length === 0 ||
		(responseContent.keyTakeaways.length === 1 &&
			Object.keys(responseContent.keyTakeaways[0]).length === 0)
	) {
		return '';
	}

	let markdown = `${responseContent.introduction}\n\n`;
	markdown += responseContent.keyTakeaways
		.map((keyTakeaways: any) => {
			if ('takeaway' in keyTakeaways && 'snippet' in keyTakeaways) {
				let formattedtakeaway = '';
				if (keyTakeaways.takeaway) {
					formattedtakeaway = `* ${keyTakeaways.takeaway}`;
					if (keyTakeaways.snippet) {
						formattedtakeaway += ` ${keyTakeaways.snippet}`;
					}
				}

				return formattedtakeaway;
			}
			return '';
		})
		.join('\n');
	return markdown;
};
